import Icon from '@/components/ui/AppIcon';


interface ResourceCardProps {
  title: string;
  description: string;
  icon: string;
  downloadUrl: string;
  fileSize: string;
}

export default function ResourceCard({
  title,
  description,
  icon,
  downloadUrl,
  fileSize,
}: ResourceCardProps) {
  return (
    <div className="p-6 rounded-lg border border-border bg-card hover:shadow-natural transition-all duration-300">
      <div className="flex items-start space-x-4">
        <div className="flex-shrink-0 w-12 h-12 rounded-lg bg-surface text-primary flex items-center justify-center">
          <Icon name={icon as any} size={24} />
        </div>
        <div className="flex-1">
          <h4 className="font-heading font-semibold text-base text-text-primary mb-2">
            {title}
          </h4>
          <p className="text-sm text-text-secondary mb-4">{description}</p>
          <div className="flex items-center justify-between">
            <span className="text-xs text-text-secondary">{fileSize}</span>
            <a
              href={downloadUrl}
              className="inline-flex items-center space-x-1 text-sm font-medium text-primary hover:text-secondary transition-colors duration-200"
            >
              <span>Download</span>
              <Icon name="ArrowDownTrayIcon" size={16} />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}